function SelectCellRenderer(params) {
  

  const celldata = params.colDef?.options;
  if (!celldata) {
    return handleNoCellData(params);
  }

  try {
    if (Array.isArray(params.value)) {
      return handleArrayValue(params.value, celldata);
    } else if (typeof params.value === "object" && params.value !== null) {
      return handleObjectValue(params.value, celldata);
    } else {
      return handleStringOrNumberValue(params.value, celldata);
    }
  } catch (error) {
    console.error("Error in SelectCellRenderer:", error);
    return "";
  }
}

function handleArrayValue(value, celldata) {
  const filteredData = celldata.filter((item) => value.includes(item._id));
  return filteredData.map((item) => item.option_name).join(", ") || "";
}

function handleObjectValue(value, celldata) {
  return value.option_name || "";
}

function handleStringOrNumberValue(value, celldata) {
  const ids = String(value).split(",");
  const filteredData = celldata.filter((item) => ids.includes(item._id));
  return filteredData.map((item) => item.option_name).join(", ") || "";
}

function handleNoCellData(params) {
  const groupColumn = params.api?.columnModel?.rowGroupColumns?.[0];
  const options = groupColumn?.colDef?.options;
  if (Array.isArray(options)) {
    return options.find((item) => item._id === params.value)?.option_name || params.value;
  }
  return params.value;
}

export default SelectCellRenderer;
